import React from 'react'
import PasienService from '../Service/pasienService'
import FormInput from './formInput'
import BloodService from '../Service/blood_groupService'
import Customer_RelationService from '../Service/customer_relationService'
import ModalHapus from './modalHapus'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import ModalHapusList from './modalHapusList'
import { config } from '../Config/config'

export default class index extends React.Component {
    pasienModel = {
        fullname: "",
        customer_relation_id: "",
        usia: 0,
        jumlah_janji_dokter: 0,
        jumlah_chat_online: 0,
        dob: null,
        gender: "",
        height: 0,
        weight: 0,
        rhesus_type: "",
        blood_group_id: "",
        customer_member_id: "",
        parent_biodata_id: localStorage.getItem(config.biodata_id),
        mau_dihapus: false
    }

    constructor() {
        super()
        this.state = {
            List: [],
            ListBlood: [],
            ListCostumer_Relation: [],
            Model: this.pasienModel,
            errors: {},
            showModalDel: false,
            showModalDel: false,
            TotalPage: 0,
            count: 0,
            filter: {
                search: "",
                order: "",
                page: '1',
                pageSize: '5',
                urut: 'nama',
                biodata_id: localStorage.getItem(config.biodata_id)
            },

            ListDelete: [],
            ListNameDelete: []
        }
    }

    loadList = async () => {
        const respon = await PasienService.getAllFilter(this.state.filter)
        const responBlood = await BloodService.getAll()
        const responCustomer_Relation = await Customer_RelationService.getAll()
        const responCount = await PasienService.countData(this.state.filter)


        if (respon.success) {
            let count = 0
            if (responCount.result !=undefined) {
                count = responCount.result.count
            }
            this.setState({
                List: respon.result,
                ListBlood: responBlood.result,
                ListCostumer_Relation: responCustomer_Relation.result,
                TotalPage: Math.ceil(count / this.state.filter.pageSize)
            }, () => { console.log(count) })

        }


    }

    componentDidMount() {
        this.loadList()
        console.log(localStorage.getItem(config.biodata_id))
    }

    //untuk filter
    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }

    //untuk merubah nama dan description di form input
    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        })
    }

    //untuk merubah nama dan description di form input
    // urutHandler = (value) => {
    //     this.setState({
    //         filter: {
    //             ...this.state.filter,
    //             [field]: value
    //         }
    //     })
    // }

    //untuk button submit
    saveHandler = async () => {
        if (this.handleValidation()) {
            if (this.state.Mode == "UBAH PASIEN") {
                const respon = await PasienService.EditData(this.state.Model)
                if (respon.success) {
                    alert("Success Update Data")
                    this.loadList()
                    this.setState({
                        Model: this.pasienModel,
                        showModal: false
                    })
                }
            }
            else {
                const respon = await PasienService.addData(this.state.Model)
                if (respon.success) {
                    alert("Succes Save Data")
                    this.loadList()
                    this.setState({
                        Model: this.pasienModel,
                        showModal: false
                    })
                }
            }
        } else {
            alert("Form has errors.")
        }
    }




    //untuk modal
    editHandler = async (id) => {
        console.log(id)
        const respon = await PasienService.getByCustomerId(id)

        console.log(respon)
        this.setState({
            Mode: "UBAH PASIEN",
            showModal: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    createHandler = () => {
        this.setState({
            Mode: "TAMBAH PASIEN",
            showModal: true,
            Model: this.pasienModel
        })
        console.log(this.state.showModal)
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            showModal: false,
            showModalDel: false,
            showModalDel2: false
        })
    }

    //button checkbox delete
    deleteCheck = async (id) => {
        const { ListDelete } = this.state
        // const {ListNameDelete} = this.state
        const respon = await PasienService.getByCustomerId(id)


        if (respon.success) {
            var data = {
                biodata_id: respon.result.biodata_id,
                customer_member_id: respon.result.customer_member_id,
                customer_id: respon.result.customer_id,
                fullname: respon.result.fullname
            }


            let index = ListDelete.findIndex(x => x.biodata_id === data.biodata_id && x.customer_id === data.customer_id
                && x.customer_member_id === data.customer_member_id && x.fullname === data.fullname)

            if (index == -1) {
                ListDelete.push(data)
            } else {
                ListDelete.splice(index, 1)
            }

            console.log(ListDelete)

            this.setState({
                Model: respon.result
            })
        }


    }

    //button awal List delete
    deleteHandlerr = () => {
        this.setState({
            showModalDel2: true
        })
    }

    //button modal List yakin delete
    deleteHandlerr2 = async () => {
        let tmplist = this.state.ListDelete
        console.log(tmplist)

        for (let i = 0; i < tmplist.length; i++) {
            const respon = await PasienService.DeleteData(tmplist[i])
            if (respon.success) {
                this.loadList()
            }
        }
        this.setState({
            showModalDel2: false
        })
        window.location.href = ('/pasien')
    }

    //button awal delete
    deleteHandler = async (id) => {
        const respon = await PasienService.getByCustomerId(id)
        this.setState({
            showModalDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }

    }

    //button modal yakin delete
    deleteHandler2 = async () => {
        let tmpID = this.state.Model
        console.log(tmpID)
        const respon = await PasienService.DeleteData(tmpID)
        // console.log(this.state.Model._id)
        if (respon.success) {
            alert("succes Delete Data")
            this.loadList()
            this.setState({
                showModalDel: false
            })
        }
    }


    // untuk validasi
    handleValidation() {
        let fields = this.state.Model
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["fullname"]) {
            formIsValid = false;
            errors["nama"] = "Nama Lengkap harus diisi";
        }

        if (!fields["dob"]) {
            formIsValid = false;
            errors["tanggal_lahir"] = "Tanggal Lahir harus diisi";
        }

        if (!fields["gender"]) {
            formIsValid = false;
            errors["gender"] = "Jenis Kelamin harus dipilih";
        }

        if (!fields["customer_relation_id"]) {
            formIsValid = false;
            errors["customer_relation_id"] = "Relasi harus dipilih";
        }


        this.setState({ errors: errors });
        return formIsValid;
    }

    //untuk membuat sort
    sortHandler = () => {
        let sort = ''
        sort = this.state.filter.order == '' ? '1' : '-1'
        sort = this.state.filter.order == '-1' ? '1' : '-1'

        this.setState({
            filter: {
                ...this.state.filter,
                ['order']: sort
            }
        }, () => this.loadList())
    }

    //untuk mengambil total halaman
    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pageSize"]: size
            }
        }, () => this.loadList())
    }

    //untuk membuat nomor halaman, ke hamalan 1, 2 dst 
    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadList())
    }

    renderPagination() {
        let item = []
        console.log(this.state.TotalPage)
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return (
            <Pagination>{item}</Pagination>
        )
    }



    render() {
        const { List } = this.state
        return (
            <div class="container">
                {/* {JSON.stringify(this.state.Model)} */}
                <div >

                    <table class="table">
                        <tr>
                            <td>

                                <div class="card-box profile-header">

                                    <div class="profile-view">
                                        <div class="profile-img">
                                            <a href="#"><img class="avatar" src={localStorage.getItem(config.image_path)} alt="" /></a>

                                        </div>
                                    </div>

                                    <div>
                                        <div >
                                            <br />
                                            <div class='text-center'>
                                                <i class="fa fa-star bintang mb-2"></i>
                                                <h3 >Bronze Member</h3>
                                                <h3 class="card-title">Since 2021</h3> <br />
                                            </div>

                                            <div >
                                                <br /><br /><br />
                                                <h4><a href="/pasien" class="name">Pasien</a></h4> <br />
                                                <h4><a href="#/" class="name">Pembelian Obat</a> </h4> <br />
                                                <h4><a href="/rencana_kedatangan" class="name">Rencana Kedatangan</a> </h4> <br />
                                                <h4><a href="#/" class="name">Riwayat Chat Dokter</a> </h4> <br />
                                            </div>



                                        </div>
                                    </div>


                                </div>

                            </td>


                            <td>
                                <div class="content">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <h1>Daftar Pasien</h1> <br />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card-box">

                                                <div class="form-group row float-right">
                                                    <h4 class="col-form-label col-md-5 mr-2">Urutkan: </h4>

                                                    <select class="form-select btn-outline-primary" onChange={this.filterHandler("urut")}>
                                                        <option value="nama" >Nama</option>
                                                        <option value="usia" >Usia</option>
                                                    </select>

                                                </div>

                                                <div class="input-group col-5 mb-1 float-left">
                                                    <input class="form-control rounded-left" type="text" placeholder="Cari Nama Pasien" onChange={this.filterHandler("search")} />
                                                    <div class="input-group-append" onClick={this.loadList} >
                                                        <button class="btn btn-primary rounded-right" type="button">

                                                            <i class="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <br /> <br /> <br />


                                                <div class="card-header">
                                                    <button type="button" class="btn btn-primary float-right" onClick={this.createHandler}>Tambah</button>

                                                    <div class="float-right mr-1">

                                                        <button type="button" class="btn btn-outline-success dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                                                            Show Data
                                                            </button>

                                                        <ul class="dropdown-menu">
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('5')} className="dropdown-item">5</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('10')} className="dropdown-item">10</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('20')} className="dropdown-item">20</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('30')} className="dropdown-item">30</a></li>
                                                        </ul>

                                                    </div>


                                                    <div class="float-right mr-1">

                                                        <button type="button" class="btn btn-outline-warning" onClick={this.sortHandler} >
                                                            Asc / Dsc
                                                            </button>

                                                    </div>



                                                    <button type="button" class="btn btn-danger" onClick={() => this.deleteHandlerr(this.state.ListDelete)}>Hapus</button>
                                                </div>


                                                <div class="card-body p-0">
                                                    <div class="table-responsive">
                                                        <table class="table mb-0">
                                                            <thead class="d-none">
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th class="float-right"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    List.map(data => {
                                                                        return (
                                                                            <tr >
                                                                                <td class="text-left">
                                                                                    <input class="form-check-input mt-3 ml-1" type="checkbox" onClick={() => this.deleteCheck(data._id)} />
                                                                                </td>

                                                                                <td>
                                                                                    <h2>
                                                                                        {data.nama}
                                                                                        <span>{data.hubungan}, {data.usia} Tahun</span>
                                                                                        <span>{data.jumlah_chat_online} Chat Online, {data.jumlah_janji_dokter} Janji Dokter</span>
                                                                                    </h2>

                                                                                </td>
                                                                                <td class="text-right">
                                                                                    <button class="btn btn-outline-primary take-btn mr-1" onClick={() => this.editHandler(data._id)}>Ubah</button>
                                                                                    <button class="btn btn-outline-danger take-btn" onClick={() => this.deleteHandler(data._id)}>Hapus</button>
                                                                                </td>
                                                                            </tr>

                                                                        )
                                                                    })
                                                                }

                                                            </tbody>
                                                        </table>
                                                        <div class="float-right mt-2">
                                                            {this.renderPagination()}
                                                        </div>



                                                        <FormInput
                                                            changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            Model={this.state.Model}
                                                            CreateHandler={this.createHandler}
                                                            ShowModal={this.state.showModal}
                                                            EditHandler={this.editHandler}
                                                            CancelHandler={this.cancelHandler}
                                                            errors={this.state.errors}
                                                            Mode={this.state.Mode}
                                                            ListBlood={this.state.ListBlood}
                                                            ListCostumer_Relation={this.state.ListCostumer_Relation}
                                                        />
                                                        <ModalHapus changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            CreateHandler={this.createHandler}
                                                            ShowModalDel={this.state.showModalDel}
                                                            CancelHandler={this.cancelHandler}
                                                            DeleteHandler2={this.deleteHandler2}
                                                            List={List}
                                                            Model={this.state.Model}
                                                        />
                                                        <ModalHapusList changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            CreateHandler={this.createHandler}
                                                            ShowModalDel2={this.state.showModalDel2}
                                                            CancelHandler={this.cancelHandler}
                                                            List={List}
                                                            Model={this.state.Model}
                                                            ListDelete={this.state.ListDelete}
                                                            DeleteHandlerr2={this.deleteHandlerr2}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>


                </div>
            </div>
        )
    }
}